import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import { useStateSelector } from "utils/field";
import { useOutsideClickHook } from "utils/outsideClick";

import DropDown from "components/Dropdown";
import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";

import Delete from "assets/images/icons/JSX/Delete";

import classes from "./style.module.scss";

export default React.memo(({ accessor, parentAccessor, type, change }) => {
    const dispatch = useDispatch();

    const [menuOpen, toggleMenuOpen] = useState(false);
    const [deleteDialogOpen, toggleDeleteDialog] = useState(false);

    const ref = useOutsideClickHook(() => toggleMenuOpen(false));

    const supplSystems = useStateSelector(`${parentAccessor}.supplSystems.systems`) || {};

    const handleDelete = () => {
        if (type === "radiantHeating") {
            change(`${parentAccessor}.radiantHeating`, {});
            dispatch(removeFormErrors(`${parentAccessor}.radiantHeating`));
        } else if (type === "additionalOpenings") {
            change(`${parentAccessor}.additionalOpenings`, {});
            dispatch(removeFormErrors(`${parentAccessor}.additionalOpenings`));
        } else if (type === "supplSystems") {
            const filteredSystems = Object.entries(supplSystems).reduce((acc, [key, value]) => {
                if (key === accessor.split("systems.")[1]) {
                    return acc;
                }
                return {
                    ...acc,
                    [key]: value,
                };
            }, {});

            change(`${parentAccessor}.supplSystems.systems`, filteredSystems);
            dispatch(removeFormErrors(accessor));
        }
    };

    return (
        <div className={classes.actions} ref={ref}>
            <div className={classes.menu}>
                <div className={classes.dots} onClick={() => toggleMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <DropDown
                    className={classes.dropDown}
                    open={menuOpen}
                    toggleOpen={toggleMenuOpen}
                    options={[
                        {
                            label: (
                                <span>
                                    <Delete /> Delete
                                </span>
                            ),
                            className: classes.delete,
                            onClick: () => toggleDeleteDialog(true),
                        },
                    ]}
                />
            </div>
            <Dialog open={deleteDialogOpen}>
                <CloseDialog closeActions={() => toggleDeleteDialog(false)} />
                <div className={classes.dialog}>
                    <h3>Are you sure you want to delete this heating system?</h3>
                    <div className={classes.footer}>
                        <Button type="hollow" onClick={() => toggleDeleteDialog(false)}>
                            Cancel
                        </Button>
                        <Button onClick={() => handleDelete()} type="red">
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
});
